"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/dialog/examples/index.ts';
var DialogExample = /** @class */ (function () {
    function DialogExample() {
        var _this = this;
        this.autofocus = true;
        this.basic = false;
        this.closeOnEscapeKey = true;
        this.closeOnOutsideClick = true;
        this.hasBackdrop = true;
        this.inline = false;
        this.isOpen = false;
        this.transition = true;
        this.isSubmitting = false;
        this.close = function () {
            _this.isOpen = false;
            _this.isSubmitting = false;
        };
        this.submit = function () {
            _this.isSubmitting = true;
            setTimeout(function () {
                _this.close();
                mithril_1.default.redraw();
            }, 1000);
        };
    }
    DialogExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                label: 'Show dialog',
                intent: 'primary',
                onclick: function () { return _this.isOpen = !_this.isOpen; }
            }),
            (0, mithril_1.default)(_1.Dialog, {
                autofocus: this.autofocus,
                basic: this.basic,
                closeOnEscapeKey: this.closeOnEscapeKey,
                closeOnOutsideClick: this.closeOnOutsideClick,
                content: (0, mithril_1.default)(_1.Input, { autofocus: true, fluid: true }),
                hasBackdrop: this.hasBackdrop,
                isOpen: this.isOpen,
                inline: this.inline,
                onClose: this.close,
                title: 'Dialog title',
                transitionDuration: this.transition ? 200 : 0,
                footer: (0, mithril_1.default)(".".concat(_1.Classes.ALIGN_RIGHT), [
                    (0, mithril_1.default)(_1.Button, {
                        label: 'Close',
                        onclick: this.close
                    }),
                    (0, mithril_1.default)(_1.Button, {
                        loading: this.isSubmitting,
                        label: 'Submit',
                        intent: 'primary',
                        onclick: this.submit
                    })
                ])
            })
        ]);
    };
    DialogExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.autofocus,
                label: 'Auto focus',
                onchange: function () { return _this.autofocus = !_this.autofocus; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnEscapeKey,
                label: 'Close on ESC key',
                onchange: function () { return _this.closeOnEscapeKey = !_this.closeOnEscapeKey; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnOutsideClick,
                label: 'Close on outside click',
                onchange: function () { return _this.closeOnOutsideClick = !_this.closeOnOutsideClick; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.inline,
                label: 'Render inline',
                onchange: function () { return _this.inline = !_this.inline; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasBackdrop,
                label: 'Backdrop',
                onchange: function () { return _this.hasBackdrop = !_this.hasBackdrop; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.transition,
                label: 'Transition',
                onchange: function () { return _this.transition = !_this.transition; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.basic,
                label: 'Basic',
                onchange: function () { return _this.basic = !_this.basic; }
            })
        ];
    };
    return DialogExample;
}());
exports.DialogExample = DialogExample;
